import { useEffect, useState, useContext } from 'react';
import { useTracksStore } from '../store/tracks.store';
import { useOrganizationStore } from '../store/organization.store';
import { useLocation } from 'react-router-dom';
import { FirebaseContext } from '../components/Firebase';

const TracksListener: React.FC = () => {
  const { initTracks, clearTracks } = useTracksStore();
  const location = useLocation();
  const firebase = useContext(FirebaseContext);
  const [user, setUser] = useState<any>(null);

  // Get current organization from the store
  const currentOrgId = useOrganizationStore(state => state.currentOrgId);
  const isOrgLoading = useOrganizationStore(state => state.isLoading);

  useEffect(() => {
    if (!firebase) return;
    const unsubscribe = firebase.auth.onAuthStateChanged(async (user: any) => {
      if (user) {
        // Force refresh the ID token to ensure Firestore has valid auth
        await user.getIdToken(true);
        setUser(user);
      } else {
        setUser(null);
        // Clear tracks on logout
        clearTracks();
      }
    });

    return () => unsubscribe();
  }, [firebase, clearTracks]);

  // Initialize or switch tracks when user is logged in and on library page
  // This effect handles both initial load and organization switching
  useEffect(() => {
    if (user && location?.pathname === '/library' && !isOrgLoading && firebase) {
      // Initialize/switch tracks for the current organization
      initTracks(firebase, currentOrgId);
    }
  }, [user, location?.pathname, firebase, isOrgLoading, currentOrgId, initTracks]);

  return null;
};

export default TracksListener;
